import React from 'react'
import {Outlet} from 'react-router'
import {ContentArea, PageWrapper} from './Accounts.styles'

// Accounts Layout
// Parent shell for all /accounts/* routes.
// The page title/subtitle render in the app shell's AppHeader (see its
// routeTitleData). The toolbar row (tabs + search + CTA) lives in each child page

export function Accounts() {
  return (
    <PageWrapper data-theme="ooe-v1">
      <ContentArea>
        <Outlet />
      </ContentArea>
    </PageWrapper>
  )
}
